import axios from "axios";
import { decryptToken } from "../Encryption/EncryptionToken";

let apiClient;
let ssoOrManager = window.location.href.includes("manager");

const loadConfig = async () => {
  try {
    const response = await fetch(`${window.location.origin}/SRFund/Helpers/main.json`);
    const config = await response.json();
    return config;
  } catch (error) {
    console.error("Error loading config:", error);
    throw error;
  }
};

// تجديد Access Token باستخدام Refresh Token
const refreshAccessToken = async () => {
  const config = await loadConfig();
  const refreshToken = ssoOrManager
    ? sessionStorage.getItem("RefreshtokenManager")
    : sessionStorage.getItem("Refreshtoken");

  try {
    const response = await axios.post(
      `${config.domainUrl}/api/Account/RefreshToken`,
      { token: refreshToken }
    );

    const { accessToken } = response.data.result.token;
    const { refreshToken: newRefreshToken } = response.data.result.refreshToken;

    if (ssoOrManager) {
      sessionStorage.setItem("AccessTokenManager", accessToken);
      sessionStorage.setItem("RefreshtokenManager", newRefreshToken);
    } else {
      sessionStorage.setItem("AccessToken", accessToken);
      sessionStorage.setItem("Refreshtoken", newRefreshToken);
    }

    return accessToken;
  } catch (error) {
    console.error("Error refreshing token:", error);
    window.location.href = "/login";
    return null;
  }
};

export const initializeApiClient = async (ContentType) => {
  const token = ssoOrManager
    ? decryptToken("AccessTokenManager", "manager")
    : decryptToken("AccessToken", "sso");

  const config = await loadConfig();

  apiClient = axios.create({
    baseURL: config.domainUrl,
    timeout: 900000,
    withCredentials: true,
  });

  apiClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // لا تقم بتعيين Content-Type إذا كان data من نوع FormData
      if (ContentType && !(config.data instanceof FormData)) {
        config.headers["Content-Type"] = ContentType;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        const newAccessToken = await refreshAccessToken();

        if (ContentType && !(originalRequest.data instanceof FormData)) {
          originalRequest.headers["Content-Type"] = ContentType;
        }

        if (newAccessToken) {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return apiClient(originalRequest);
        }
      }
      return Promise.reject(error);
    }
  );
};

export const getApiClient = () => {
  if (!apiClient) {
    throw new Error(
      "API client is not initialized. Call initializeApiClient first."
    );
  }
  return apiClient;
};

export default loadConfig;
